import React, {useContext} from 'react';
import { Modal } from 'react-bootstrap';
import UploadFile from './UploadFile';
import { LabelText } from '../../Language';
import {LanguageContext} from '../../../containers/Language/LanguageProvider';
import { parse } from 'date-fns';
import './index.css';

const UploadFileModal = (props) => {
    
    const languageContext = useContext(LanguageContext);  
    
    const getIntakeBookTitleDetails = () => {               
        return <div style={{fontSize: 19.9}}>  
        {getTitleContractDetails()}
        {getTitleMonthDetails()}       
        </div>     
    } 

    const getTitleContractDetails = () => {               
        return <>  
        {languageContext.labels["contractcode"] && languageContext.labels["contractcode"].toLowerCase()}<span>{' '}</span>
        {props.selectedRevenue.contractCode}<span>{' - '}</span>        
        </>     
    } 

    const getTitleMonthDetails = () => {               
        return <>  
        {languageContext.labels["month"] && languageContext.labels["month"].toLowerCase()}<span>{' '}</span>
        {props.selectedRevenue.monthYear ? props.selectedRevenue.monthYear.replace('-','/'):
         props.selectedRevenue.revenueDate && (("0" + (parse(props.selectedRevenue.revenueDate, "dd/MM/yyyy", new Date()).getMonth() + 1)).slice(-2)+"/"+
         parse(props.selectedRevenue.revenueDate, "dd/MM/yyyy", new Date()).getFullYear())}
        </>     
    } 

    return (
        <div className="Modal-container">
            <Modal show={props.showModel} onHide={() => { props.onHideHandler(); }}>
                {
                    props.showHeader &&
                    <Modal.Header closeButton className="Modal-header" >
                        <Modal.Title className="Model-header-title">
                            {<>
                             {props.isCashRegister ?
                                <>  
                                <div><LabelText tid={props.headerTitle} /></div> 
                                 {getIntakeBookTitleDetails()}
                              </> : <LabelText tid={props.headerTitle} /> }
                            </>}
                        </Modal.Title>
                    </Modal.Header>
                }
                <Modal.Body>
                    <UploadFile acceptFileType={props.acceptFileType} 
                                handlerOnUploadClick={props.handlerOnUploadClick}
                                isCashRegister={props.isCashRegister}
                                allowedFileType={props.allowedFileType}
                                selectedRowIndex={props.selectedRowIndex}
                                selectedRevenue={props.selectedRevenue}
                                selectedRevenueCashRegisterFile={props.selectedRevenueCashRegisterFile} 
                                handlerOnDeleteFileClick={props.handlerOnDeleteFileClick}
                                UserId={props.UserId}
                                isModifying={props.isModifying}
                                weeklyStartDate={props.weeklyStartDate}
                                weeklyEndDate={props.weeklyEndDate}
                    />
                </Modal.Body>
            </Modal>
        </div>)
}

export default UploadFileModal;